import React from 'react';
import {useParams} from 'react-router';
import useSearch from '../../../hooks/useSearch';
import SubtleButton from '../../SubtleButton';
import {useObsidianContext} from '../../../context/ObsidianProvider';
import {Platform} from '../../../types';

export default function Search() {
  const {term} = useParams<{term: string}>();
  const {obsidian} = useObsidianContext();
  const [searchResults, loading] = useSearch(term, 20);

  const resultsMarkup =
    loading || searchResults == null ? (
      <p>Loading...</p>
    ) : (
      searchResults.map((song) => (
        <SubtleButton onClick={() => obsidian.play(song, Platform.AppleMusic)}>
          {`${song.name} - ${song.id}`}
        </SubtleButton>
      ))
    );

  return (
    <div>
      <strong>Songs:</strong>
      {resultsMarkup}
    </div>
  );
}
